import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody, AixContentHeader } from "@aix/ui"
import { useAtomValue } from "jotai"
import { ReactElement } from "react"
import AIVoiceoverTool from "~/components/Steppers/AIVoiceoverTool"
import CustomHead from "~/components/SEOHead/CustomHead"
import AppLayout from "~/layouts/AppLayout"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import { navStyleAtom } from "~/context/jotai"
import { getPageSEO } from "~/utils/seo"

function AIVoiceoverPage() {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "AI Voiceover Generator" }]
  const aiVoiceoverSEO = getPageSEO("tools/ai-voiceover")
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <>
      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}
      <CustomHead
        title={aiVoiceoverSEO.title}
        description={aiVoiceoverSEO.description}
        keywords={aiVoiceoverSEO.keywords}
        pageType={aiVoiceoverSEO.pageType}
        url="https://vidmax.ai/tools/ai-voiceover"
      />
      <div className="space-y-6">
        {/* <AixContentHeader className="px-8 pt-8">
          <h1 className="text-2xl font-bold">AI Voiceover Generator</h1>
        </AixContentHeader> */}
        <AixContentBody>
          <AIVoiceoverTool />
        </AixContentBody>
      </div>
    </>
  )
}

function AIVoiceoverPageWrapper() {
  return (
    <AppLayout>
      <AIVoiceoverPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/tools/ai-voiceover")({
  component: AIVoiceoverPageWrapper,
})
